// DTOs para el módulo de Calendario de Empleado

/**
 * Representa una fecha simple (sin hora)
 */
export interface SimpleDate {
  year: number;
  month: number; // 1-12
  day: number;
}

/**
 * Rango de fechas
 */
export interface SimpleDateRange {
  fromDate: SimpleDate;
  toDate: SimpleDate;
}

/**
 * Información de calendario del empleado para un día específico
 */
export interface EmployeeCalendar {
  id?: number;
  employeeId: number;
  calendarDay: string; // Fecha ISO
  workdayHours?: number | null;
  workdayStart?: string;
  workdayFinish?: string;
  workdayActivityStart?: string;
  workdayActivityFinish?: string;
  totalActivityWorkHours?: number;
  totalActivityNonWorkHours?: number;
  extraHours?: number;
  adjustmentHours?: number;
  adjustmentExtraHours?: number;
  adjustmentNonWorkHours?: number;
  adjustmentConcept?: string;
  adjustmentNonWorkConcept?: string;
  personalNotes?: string;
  recordStatus?: number;
  recordTitle?: string;
  recordInfo?: string;
  isTelework?: boolean;
  teleworkNotes?: string;
  availableStartHour?: string;
  availableEndHour?: string;
  hoursBagDelta?: number;
  // Campos para festivos y descanso
  dayType?: number; // 0=Regular, 1=Descanso, 2=Festivo Nacional, 3=Festivo Local, 4=Festivo Empresa
  description?: string; // Descripción del festivo/descanso
  isCheckinAllowed?: number; // 0=No permitido, 1=Permitido
  countsAsVacation?: boolean | null;
}

/**
 * Tipos de día del calendario
 */
export const CalendarDayType = {
  REGULAR_DAY: 0,
  REST_DAY: 1,
  NATIONAL_HOLIDAY: 2,
  LOCAL_HOLIDAY: 3,
  COMPANY_HOLIDAY: 4,
} as const;

/**
 * Información completa de vacación
 */
export interface FullVacation {
  id?: number;
  employeeId: number;
  employeeName?: string;
  firstname?: string;
  lastname?: string;
  fromDate: SimpleDate;
  toDate: SimpleDate;
  fromHour?: string;
  toHour?: string;
  recordStatus: number;
  recordType: number;
  recordTitle: string;
  recordInfo?: string;
  requestInfo?: string;
  hours?: number;
  days?: number;
  requestId?: number;
  requestStatus?: number;
  hoursBagDelta?: number;
  hoursBagType?: number | null; // Tipo de bolsa de horas (6 = vacaciones, null = ausencia retribuida)
  hoursBagName?: string; // Nombre de la bolsa de horas
  profilePicture?: string;
}

/**
 * Solicitud de procedimiento/vacación
 */
export interface ProcedureRequest {
  id?: number;
  employeeId: number;
  requestType: number;
  requestTitle: string;
  requestDescription?: string;
  requestStatus: number;
  fromDate?: SimpleDate;
  toDate?: SimpleDate;
  hours?: number;
  days?: number;
  approverEmployeeIds?: number[];
  notifiedEmployeeIds?: number[];
  documentIds?: string;
  documents?: unknown[];
  creationDate?: string;
  updateDate?: string;
}

/**
 * Grupo de datos de vacaciones y procedimientos
 */
export interface ProcedureVacationGroup {
  vacations?: FullVacation[];
  approvedRequests?: Array<FullVacation | unknown>; // FullProcedureRequest convertido a compatible
  pendingRequests?: Array<FullVacation | unknown>; // FullProcedureRequest convertido a compatible
  approverRequests?: ProcedureRequest[];
}

/**
 * Datos del día seleccionado en el calendario
 */
export interface CalendarDayData {
  date: Date;
  employeeCalendar: EmployeeCalendar | null;
  vacations: FullVacation[];
  isWeekend: boolean;
  isToday: boolean;
  hasVacation: boolean;
}
